import { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { changePhoneNumberStepAnalytics as analytics } from '../../analytics';

export const AnalyticsSpy = () => {
    const formApi = useForm();
    const { active } = useFormState({
        subscription: { active: true },
    });

    useEffect(() => {
        const { error, touched, value } = formApi.getFieldState('changedPhoneNumber') || {};

        if (!active) {
            if (touched && error) {
                sendEvent(analytics.incorrect);
            }
            if (touched && value && !error) {
                sendEvent(analytics.correct);
            }
        } else if (active) {
            sendEvent(analytics.focus);
        }
    }, [active, formApi]);

    return null;
};
